/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest, select } from 'redux-saga/effects';
import * as Actions from './actions';
import * as cartActions from '../../services/Cart/actions';
import * as contactActions from '../ContactInfo/actions';
import * as getCheckoutActions from '../FuncComp/sagas.helper';
import * as TaggingActions from '../Common/Tagging.js/actions';
import { eventDispatcher } from '../../components/common/Tagging/index';
import * as Constants from './Constants';
import * as shippingSelectors from './selectors/shippingInfoSelectors';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
import { logError } from '../../services/loggerService';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import {
  isPreorder,
  getServiceUrlandE2eRequestId,
  isFuncComp,
  isShippingTabEnabled,
  prefetchGetShippingOptions,
} from '../../components/common/Helpers/index';
import { checkInvalidCaseCartError } from '../../components/common/Helpers/commonLog';
import * as CheckoutConstants from '../FuncComp/Constants';
import { getThrottleKeys } from '../../components/common/Helpers/taggingHelper';

export function* handleShippingInfodata(data, homePhone, apiResponseShippingInfo) {
  let errorShipping = false;
  let serviceDetails = null;
  if (apiResponseShippingInfo && apiResponseShippingInfo.data && !apiResponseShippingInfo.data.errors) {
    yield put({ type: Constants.GET_DETAILS_FROM_API_SUCCESS, response: apiResponseShippingInfo.data });
    yield put({ type: 'API_LOADED', response: true });
    hideLoader();
    if (data === 'preOrderNSE') {
      let homePhoneAdded = false;
      const homePhoneResponse = homePhone?.cartDetailsJson?.dueTodayList?.filter(
        (item) => item.isHomePhone !== undefined && item.isHomePhone === true,
      );
      if (homePhoneResponse && homePhoneResponse.length > 0) {
        homePhoneAdded = true;
      }
      const apiResponse1 = yield call(
        Actions.updateShippingOptions,
        apiResponseShippingInfo?.data?.lines?.[0]?.shippingOptions?.[0],
        null,
        null,
        homePhoneAdded,
      );
      if (apiResponse1 && apiResponse1.data && !apiResponse1.data.errors) {
        if (
          apiResponse1.data.serviceHeader &&
          ((apiResponse1.data.serviceHeader.statusMsg && apiResponse1.data.serviceHeader.statusMsg === 'SUCCESS') ||
            (apiResponse1.data.serviceHeader.statusCode && apiResponse1.data.serviceHeader.statusCode === '00'))
        ) {
          yield call(cartActions.getCartDetails, { pageName: data });
          yield put({ type: Constants.POST_SHIPPING_OPTION_SUCCESS, response: apiResponse1.data });
          hideLoader();
        } else {
          hideLoader();
        }
      }
    }
  } else {
    if (
      apiResponseShippingInfo &&
      ((apiResponseShippingInfo.data && apiResponseShippingInfo.data.errors) ||
        (apiResponseShippingInfo.request && apiResponseShippingInfo.request.status !== 200))
    ) {
      errorShipping = true;
      serviceDetails = getServiceUrlandE2eRequestId('getShippingInfoData', apiResponseShippingInfo);
      if (apiResponseShippingInfo.data.loggerData)
        apiResponseShippingInfo.data.loggerData.note = `getShippingInfoData ${apiResponseShippingInfo?.data?.loggerData.note}`;
      logger(apiResponseShippingInfo?.data?.loggerData);
      hideLoader();
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponseShippingInfo?.data?.errors[0]?.notifyMessage });
    }
    yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
    yield put({
      type: 'UPDATE_SAVE_SELECTED_OPTION',
      data: apiResponseShippingInfo.data.lines[0].shippingOptions.filter((item) => item.addedShippingOptionId === 'true'),
    });
  }
}
export function* handleShippingInfoCatchCase(error) {
  let errorShipping = false;
  let serviceDetails = null;
  if (error && error.response) {
    errorShipping = true;
    serviceDetails = {
      method: 'getShippingInfoData',
    };
    yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
    yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
  }
  if (error) {
    hideLoader();
  }
}
function* getShippingInfoData({ data, homePhone, isApiPrefetch }) {
  console.log('96 akshay');
  const errorShipping = false;
  let apiResponse;
  const getStateShippingInfoDetails = (state) => state?.shippingInfo?.ShippingInfoDetails;
  const getShippingOptionsapiResponse = yield select(getStateShippingInfoDetails);
  const cartPage = window.location.href.includes('cart.html');
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  if (!isApiPrefetch) {
    showLoader();
  }
  try {
    if (prefetchGetShippingOptions()) {
      if (getShippingOptionsapiResponse && !cartPage) {
        const PrefetchedapiResponse = { data: getShippingOptionsapiResponse };
        apiResponse = PrefetchedapiResponse;
      } else {
        apiResponse = yield call(Actions.getDetails, data);
      }
    } else {
      apiResponse = yield call(Actions.getDetails, data);
    }
    yield handleShippingInfodata(data, homePhone, apiResponse);
  } catch (error) {
    yield handleShippingInfoCatchCase(error);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}
function* getSlotsSDD({ data, dueTodayList }) {
  let errorShipping = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const apiResponseGetSlots = yield call(Actions.getslots, data, dueTodayList);
    if (apiResponseGetSlots && apiResponseGetSlots.data && !apiResponseGetSlots.data.errors && !apiResponseGetSlots.data.showSDDErrorMessage) {
      yield put({ type: Constants.GET_SLOTS_SDD_SUCCESS, response: apiResponseGetSlots.data });
      hideLoader();
    } else {
      if (
        apiResponseGetSlots &&
        ((apiResponseGetSlots.data && apiResponseGetSlots.data.errors) || (apiResponseGetSlots.request && apiResponseGetSlots.request.status !== 200))
      ) {
        errorShipping = true;
        serviceDetails = getServiceUrlandE2eRequestId('getSlotsSDD', apiResponseGetSlots);
        if (apiResponseGetSlots.data.loggerData)
          apiResponseGetSlots.data.loggerData.note = `getSlotsSDD ${apiResponseGetSlots?.data?.loggerData.note}`;
        logger(apiResponseGetSlots?.data?.loggerData);
        hideLoader();
        yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponseGetSlots?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
    }
  } catch (errorGetSlots) {
    if (errorGetSlots && errorGetSlots.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'getSlotsSDD',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (errorGetSlots) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}
function* getEnabledDevices({ data }) {
  let errorShipping = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const apiResponseFetchDevices = yield call(Actions.fetchDevices, data);
    if (apiResponseFetchDevices && apiResponseFetchDevices.data && !apiResponseFetchDevices.data.errors) {
      yield put({
        type: 'FETCH_SMS_DEVICES_SUCCESS',
        response: {
          fetchSMSEnabledDevices: apiResponseFetchDevices.data.devices,
        },
        commonData: {
          securePinVerifyFormVisible: false,
          sendSMS: false,
          fetchSMSEnabledDevices: true,
        },
      });
      hideLoader();
      yield put({ type: Constants.GET_DATA_SUCCESS, response: apiResponseFetchDevices.data });
      yield put({ type: Constants.GET_ENABLED_DEVICES_SUCCESS, response: apiResponseFetchDevices.data });
    } else {
      if (
        apiResponseFetchDevices &&
        ((apiResponseFetchDevices.data && apiResponseFetchDevices.data.errors) ||
          (apiResponseFetchDevices.request && apiResponseFetchDevices.request.status !== 200))
      ) {
        errorShipping = true;
        serviceDetails = getServiceUrlandE2eRequestId('getEnabledDevices', apiResponseFetchDevices);
        if (apiResponseFetchDevices.data.loggerData)
          apiResponseFetchDevices.data.loggerData.note = `getEnabledDevices ${apiResponseFetchDevices?.data?.loggerData.note}`;
        logger(apiResponseFetchDevices?.data?.loggerData);
        hideLoader();
        yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponseFetchDevices?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
    }
  } catch (errorFetchDevices) {
    if (errorFetchDevices && errorFetchDevices.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'getEnabledDevices',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (errorFetchDevices) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}
// for sending sms
function* sendSms({ data }) {
  let errorShipping = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const apiResponse = yield call(Actions.sendSms, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({
        type: 'FETCH_SMS_DEVICES_SUCCESS',
        response: {
          sendSMS: apiResponse.data,
        },
        commonData: {
          securePinVerifyFormVisible: true,
        },
      });
      hideLoader();
      yield put({ type: Constants.GET_SEND_SMS_SUCCESS, response: apiResponse.data });
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorShipping = true;
        serviceDetails = getServiceUrlandE2eRequestId('sendSms', apiResponse);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `sendSms ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
        yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
    }
  } catch (errorSendSms) {
    if (errorSendSms && errorSendSms.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'sendSms',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (errorSendSms) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}
function* cityAndState(data) {
  showLoader();
  try {
    const apiResponseZipDetails = yield call(Actions.getZipDetails, data);
    if (apiResponseZipDetails && apiResponseZipDetails.data && !apiResponseZipDetails.data.errorMessage) {
      if (
        Object.keys(apiResponseZipDetails.data).length === 0 ||
        (apiResponseZipDetails.data.errors && apiResponseZipDetails.data.errors.length > 0)
      ) {
        apiResponseZipDetails.data = { errorMessage: 'Please Enter valid Zip Code ' };
        yield put({ type: 'CITY_AND_STATE_SUCCESS', response: apiResponseZipDetails.data });
      } else {
        yield put({ type: 'CITY_AND_STATE_SUCCESS', response: apiResponseZipDetails.data });
      }
      hideLoader();
    } else {
      yield put({ type: 'CITY_AND_STATE_SUCCESS', response: apiResponseZipDetails.data });
      if (
        apiResponseZipDetails &&
        ((apiResponseZipDetails.data && apiResponseZipDetails.data.errors) ||
          (apiResponseZipDetails.request && apiResponseZipDetails.request.status !== 200))
      ) {
        if (apiResponseZipDetails.data.loggerData)
          apiResponseZipDetails.data.loggerData.note = `cityAndState ${apiResponseZipDetails?.data?.loggerData.note}`;
        logger(apiResponseZipDetails?.data?.loggerData);
        hideLoader();
      }
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    if (error) {
      hideLoader();
    }
  }
}
// code validation
function* codeValid(data) {
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(Actions.pinValidation, data.MTN, data.otp);
    if (apiResponse && apiResponse.data && apiResponse.data.status === 'SUCCESS' && !apiResponse.data.errors) {
      yield put({
        type: 'FETCH_SMS_DEVICES_SUCCESS',
        commonData: {
          showSecurePinModal: false,
          securePinVerifyFormVisible: false,
          fetchSMSEnabledDevices: false,
          sendSMS: false,
          shippingInfoComplete: true,
          shippingInfoFormVisible: true,
          AUTH_CODE_VERIFICATION_ERROR: null,
        },
      });
      hideLoader();
      yield call(getEnabledDevices, data);
    } else {
      const authCodeError = apiResponse.data && apiResponse?.data?.statusDescription;
      yield put({
        type: 'FETCH_SMS_DEVICES_SUCCESS',
        commonData: {
          showSecurePinModal: false,
          securePinVerifyFormVisible: true,
          fetchSMSEnabledDevices: false,
          sendSMS: false,
          shippingInfoComplete: false,
          shippingInfoFormVisible: true,
          securePinVerified: false,
          isMaxAttemptsExceeded: authCodeError && authCodeError.toLowerCase().indexOf('the authorization code you entered is incorrect') === -1,
          AUTH_CODE_VERIFICATION_ERROR: authCodeError,
        },
      });
      if (
        apiResponse &&
        (apiResponse?.data?.status === 'ERROR' ||
          (apiResponse.data && apiResponse.data.errors) ||
          (apiResponse.request && apiResponse.request.status !== 200))
      ) {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `codeValid ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
        yield put({ type: Constants.SHIPPING_FETCH_SMS_DEVICES_ERROR, isInvalidOTP: true, response: apiResponse?.data?.statusDescription });
      }
      hideLoader();
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}
function* selectedShippingOption(value) {
  yield put({ type: 'UPDATE_SAVE_SELECTED_OPTION', data: value.data });
}
function* resetStoreList(value) {
  yield put({ type: 'ISPU_STORES_RECEIVED', data: value });
}
function* updateShippingOptionsData(data) {
  let errorShipping = false;
  let serviceDetails = null;
  let errorDetails = false;
  let shippingInvalidCaseError = false;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.SHIPPING_INVALID_CASE_ERROR, response: shippingInvalidCaseError });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  const notifyErrorMessage = data?.selectedShipping?.notifyMessage;
  showLoader();
  yield put(notificationActions.hideNotification());
  try {
    const apiResponseUpdateShipping = yield call(
      Actions.updateShippingOptions,
      data.selectedShipping,
      data.selectedslots,
      data.sddOption,
      data.homePhoneAdded,
    );
    if (apiResponseUpdateShipping && apiResponseUpdateShipping.data && !apiResponseUpdateShipping.data.errors) {
      if (
        apiResponseUpdateShipping.data.serviceHeader &&
        ((apiResponseUpdateShipping.data.serviceHeader.statusMsg && apiResponseUpdateShipping.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponseUpdateShipping.data.serviceHeader.statusCode && apiResponseUpdateShipping.data.serviceHeader.statusCode === '00'))
      ) {
        if (data?.isCheckoutAPI) {
          const data = {
            paymentOptions: true,
            cart: true,
            shippingOptions: true,
          };
          // GIRISH CHECK
          const apiResponse = yield call(getCheckoutActions.getCheckoutDetailsCall, data);
          if (apiResponse && apiResponse.data && apiResponse.status === 200 && !apiResponse.data.errors) {
            yield call(TaggingActions.invokeTagging);
            yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_RESPONSE, response: apiResponse.data });
            yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
          } else {
            if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
              errorDetails = true;
              if (apiResponse?.data?.errors) {
                if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getCheckOutDetails ${apiResponse?.data?.loggerData.note}`;
                logger(apiResponse?.data?.loggerData);
              }
              yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
            }
            yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_ERROR, errorDetails });
            yield put(notificationActions.showErrorNotification(apiResponse?.data?.errors?.[0]?.message));
            yield put({
              type: CheckoutConstants.CEF_CHECKOUT_DETAILS_ERROR,
              response: errorDetails,
              errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
            });
            if (apiResponse && apiResponse.request && apiResponse.request.status === 200) {
              yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
            }
          }
          yield put({ type: Constants.POST_SHIPPING_OPTION_SUCCESS, response: apiResponseUpdateShipping.data });
          hideLoader();
        } else {
          yield call(cartActions.getCartDetails, { pageName: data });
          yield put({ type: Constants.POST_SHIPPING_OPTION_SUCCESS, response: apiResponseUpdateShipping.data });
          hideLoader();
        }
      } else {
        hideLoader();
      }
    } else {
      if (
        apiResponseUpdateShipping &&
        apiResponseUpdateShipping?.status === 400 &&
        apiResponseUpdateShipping.data &&
        apiResponseUpdateShipping.data.errors
      ) {
        if (checkInvalidCaseCartError(apiResponseUpdateShipping.data.errors)) {
          shippingInvalidCaseError = true;
          serviceDetails = getServiceUrlandE2eRequestId('updateShippingOptionsData', apiResponseUpdateShipping);
          yield put({
            type: Constants.CEF_SHIPPING_INFO_ERROR,
            response: true,
            errorMessage: apiResponseUpdateShipping?.data?.errors[0]?.notifyMessage,
          });
        }
      } else if (
        apiResponseUpdateShipping &&
        ((apiResponseUpdateShipping.data && apiResponseUpdateShipping.data.errors) ||
          (apiResponseUpdateShipping.request && apiResponseUpdateShipping.request.status !== 200))
      ) {
        errorShipping = true;
        serviceDetails = getServiceUrlandE2eRequestId('updateShippingOptionsData', apiResponseUpdateShipping);
        yield put({
          type: Constants.CEF_SHIPPING_INFO_ERROR,
          response: true,
          errorMessage: apiResponseUpdateShipping?.data?.errors[0]?.notifyMessage,
        });
      }
      if (apiResponseUpdateShipping.data.loggerData)
        apiResponseUpdateShipping.data.loggerData.note = `updateShippingOptionsData ${apiResponseUpdateShipping?.data?.loggerData.note}`;
      logger(apiResponseUpdateShipping?.data?.loggerData);
      hideLoader();
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.SHIPPING_INVALID_CASE_ERROR, response: shippingInvalidCaseError, serviceinfo: serviceDetails });
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'updateShippingOptionsData',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
  }
}
function* getISPUStores({ data, pageLoad }) {
  console.log(pageLoad);
  try {
    yield put({
      type: 'ISPU_FETCHING',
    });
    yield put({ type: 'CEF_ISPU_STORES_RECEIVED', response: false });
    if (!pageLoad) {
      showLoader();
    }
    console.log('data', data.data.zipCode);
    yield put({
      type: 'ISPU_ZIPCODE',
      response: data.data.zipCode,
    });
    let apiResponse;
    if (!pageLoad) {
      apiResponse = yield call(Actions.getISPUStoresAPI, data);
    } else if (pageLoad) {
      window.timerdWindow = window.setInterval(async () => {
        if (window.timerdWindow) {
          window.clearInterval(window.timerdWindow);
        }
        apiResponse = await getISPU(data);
      }, 5000);
    }
    const storeList = apiResponse?.data?.stores;
    let itemExist = false;
    const itemAvailableStores = [];
    if (storeList && storeList.length > 0) {
      storeList.forEach((store) => {
        // If any item's quantity is 0 or less then it's not available
        const deviceAvailable =
          store?.items && store?.items?.item && !store.items?.item.some((sku) => !sku.quantity || parseFloat(sku.quantity) <= 0);
        if (deviceAvailable) {
          itemExist = true;
          itemAvailableStores.push(store);
        }
      });
    }
    if (itemExist === false) {
      yield put({ type: 'ISPU_STORES_RECEIVED', response: [] });
      yield put({ type: 'CEF_ISPU_STORES_RECEIVED', response: !itemExist });
    } else {
      yield put({ type: 'ISPU_STORES_RECEIVED', response: storeList, itemAvailableStoresList: itemAvailableStores });
      yield put({ type: 'ISPU_STORES_UPDATED', response: true });
    }
    if (!pageLoad) {
      hideLoader();
    }
  } catch (error) {
    yield put({
      type: 'ISPU_STORES_RECEIVED',
      response: [],
    });
  }
}
export function getISPU(data) {
  return Actions.getISPUStoresAPI(data);
}
function* updateISPUShipping(data) {
  // debugger;
  console.log('SAGAS');
  let errorShipping = false;
  let serviceDetails = null;
  let errorDetails = false;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  // console.log("SAGASSELECTION",data.isSelectedFromISPUModal);
  showLoader();
  try {
    yield put({ type: Constants.UPDATE_ISPU_STORE_INFO, response: data.storeInfo || {} });
    const shippingThrottleKeys = getThrottleKeys(data?.cradleResponseDetails, 'FWA_Shipping');
    if (isShippingTabEnabled()) {
      // ADDING TAGGING when they click on selection of store for new Tab resedign Functionality
      // const shippingThrottleKeys = getThrottleKeys(data?.cradleResponseDetails, 'FWA_Shipping');
      eventDispatcher('sendData', {
        name: '',
        svars: {
          // evar221: 'AP Toggle Y',
          evar220: 'FWA_Express_T_Pickup',
          evar221: shippingThrottleKeys && shippingThrottleKeys.length > 0 && shippingThrottleKeys.join('|'),
          evar27: 'express pickup',
        },
      });
      let storeDeatils;
      // eslint-disable-next-line prefer-const
      storeDeatils = { ...data.storeInfo };
      storeDeatils.locationCode = data.locationCode;
      // storeDeatils = { ...data.storeInfo, ...data.locationCode};
      yield put({ type: 'DATA_SELECTED_FROM_ISPU_MODEL', response: storeDeatils || {} });
    } else {
      // const shippingThrottleKeys = getThrottleKeys(data?.cradleResponseDetails, 'FWA_Shipping');
      eventDispatcher('sendData', {
        name: '',
        svars: {
          // evar221: 'AP Toggle Y',
          evar220: 'FWA_Express_C_Pickup',
          evar221: shippingThrottleKeys && shippingThrottleKeys.length > 0 && shippingThrottleKeys.join('|'),
        },
      });
    }
    const shippingdata =
      isFuncComp() === true ? yield select(shippingSelectors.selectShippingDataFun) : yield select(shippingSelectors.selectShippingData);
    console.log('SHIPPINGDATA', shippingdata);
    const purchasePath = data.purchasePath || 'EUP';
    const lineLevelShipment = data && data.lineLevelShipment ? data.lineLevelShipment : null;
    const lineLevelShipmentSelectedLineSequenceNumber =
      data && data.lineLevelShipmentSelectedLineSequenceNumber ? data.lineLevelShipmentSelectedLineSequenceNumber : null;
    const isLineLevelSplitShipmentAllowed =
      isFuncComp() === true
        ? yield select(shippingSelectors.getLineLevelSplitShipmentFlagFun)
        : yield select(shippingSelectors.getLineLevelshipTogetherPrefFlag);
    const shipTogetherPrefFlag =
      isFuncComp() === true
        ? yield select(shippingSelectors.getLineLevelshipTogetherPrefFlagFun)
        : yield select(shippingSelectors.getLineLevelshipTogetherPrefFlag);
    const showLineLevelShippingOption = isLineLevelSplitShipmentAllowed && !shipTogetherPrefFlag;
    const showCommonShippingOption = !showLineLevelShippingOption;
    let lines = [];
    if (showCommonShippingOption) {
      if (isFuncComp() !== true) {
        // Before our code
        lines = shippingdata.map((item) => ({
          multiLineSeqNumber: item.multiLineSeqNumber,
          shipping: {
            depletionLocation: data.locationCode && data.locationCode.replace('-', ''),
            discription: 'In-Store Pickup',
          },
        }));
      } else {
        // new code for geCheckoutResponse
        const linesOb = {
          multiLineSeqNumber: shippingdata?.lines?.newLine1?.multiLineSeqNumber,
          shipping: {
            depletionLocation: data.locationCode && data.locationCode.replace('-', ''),
            discription: 'In-Store Pickup',
          },
        };
        lines.push(linesOb);
      }
    } else {
      lines = shippingdata
        .filter((option) =>
          lineLevelShipment && lineLevelShipmentSelectedLineSequenceNumber
            ? option.multiLineSeqNumber === lineLevelShipmentSelectedLineSequenceNumber ||
              option.multiLineSeqNumber === parseInt(lineLevelShipmentSelectedLineSequenceNumber)
            : option.purchasePath === purchasePath,
        )
        .map((item) => ({
          multiLineSeqNumber: item.multiLineSeqNumber,
          shipping: {
            depletionLocation: data.locationCode.replace('-', ''),
            discription: 'In-Store Pickup',
          },
        }));
    }
    if (data.homePhoneAdded) {
      lines.push({
        multiLineSeqNumber: 2,
        shipping: {
          depletionLocation: data.locationCode && data.locationCode.replace('-', ''),
          discription: 'In-Store Pickup',
        },
      });
    }
    const postObj = {
      lines,
      purchasePath,
      shipTogetherPrefFlag,
    };
    const apiResponseupdateShippingOptions = yield call(Actions.updateShippingOptionsAPI, postObj);
    if (apiResponseupdateShippingOptions && apiResponseupdateShippingOptions.status === 200 && !apiResponseupdateShippingOptions.data.errors) {
      if (!(isFuncComp() === true)) {
        yield call(cartActions.getCartDetails, { pageName: data });
      } else {
        const dataPayLoad = {
          paymentOptions: true,
          cart: true,
          shippingOptions: true,
        };
        // yield call(getCheckoutActions.getCheckoutDetailsCall, dataPayLoad);
        const apiResponse = yield call(getCheckoutActions.getCheckoutDetailsCall, dataPayLoad);
        if (apiResponse && apiResponse.data && apiResponse.status === 200 && !apiResponse.data.errors) {
          yield call(TaggingActions.invokeTagging);
          yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_RESPONSE, response: apiResponse.data });
          yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
        } else {
          if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
            errorDetails = true;
            if (apiResponse?.data?.errors) {
              if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getCheckOutDetails ${apiResponse?.data?.loggerData.note}`;
              logger(apiResponse?.data?.loggerData);
            }
            yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
          }
          yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_ERROR, errorDetails });
          yield put(notificationActions.showErrorNotification(apiResponse?.data?.errors?.[0]?.message));
          yield put({
            type: CheckoutConstants.CEF_CHECKOUT_DETAILS_ERROR,
            response: errorDetails,
            errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
          });
          if (apiResponse && apiResponse.request && apiResponse.request.status === 200) {
            yield put({ type: CheckoutConstants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
          }
        }
        // yield put({ type: Constants.POST_SHIPPING_OPTION_SUCCESS, response: apiResponseUpdateShipping.data });
        hideLoader();
      }
      if (data.callback) {
        data.callback();
      }
    } else if (apiResponseupdateShippingOptions?.data?.cartVo?.errors?.[0]) {
      errorShipping = true;
      serviceDetails = getServiceUrlandE2eRequestId('updateISPUShipping', apiResponseupdateShippingOptions);
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({
        type: Constants.CEF_SHIPPING_INFO_ERROR,
        response: true,
        errorMessage: apiResponseupdateShippingOptions?.data?.errors[0]?.notifyMessage,
      });
    } else {
      errorShipping = true;
      serviceDetails = getServiceUrlandE2eRequestId('updateISPUShipping', apiResponseupdateShippingOptions);
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({
        type: Constants.CEF_SHIPPING_INFO_ERROR,
        response: true,
        errorMessage: apiResponseupdateShippingOptions?.data?.errors[0]?.notifyMessage,
      });
    }
    hideLoader();
    if (
      apiResponseupdateShippingOptions &&
      ((apiResponseupdateShippingOptions.data && apiResponseupdateShippingOptions.data.errors) ||
        (apiResponseupdateShippingOptions.request && apiResponseupdateShippingOptions.request.status !== 200))
    ) {
      if (apiResponseupdateShippingOptions.data.loggerData)
        apiResponseupdateShippingOptions.data.loggerData.note = `updateISPUShipping ${apiResponseupdateShippingOptions?.data?.loggerData.note}`;
      logger(apiResponseupdateShippingOptions?.data?.loggerData);
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'updateISPUShipping',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}
function* updateShipping({ data, homePhoneAdded }) {
  let errorShipping = false;
  let serviceDetails = null;
  let shippingInvalidCaseError = false;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.SHIPPING_INVALID_CASE_ERROR, response: shippingInvalidCaseError });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  const notifyErrorMessage = data.notifyMessage;

  showLoader();
  yield put(notificationActions.hideNotification());
  try {
    const apiResponse = yield call(Actions.updateAddress, data, homePhoneAdded);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        yield put({ type: Constants.UPDATE_SHIPPING_ADDRESS_SUCCESS, response: apiResponse.data });
        yield put({ type: Constants.UPDATE_ADRESS_SUUCESS });
        if (isPreorder()) {
          yield call(cartActions.getCartDetails, { pageName: data });
        }
      }
      hideLoader();
    } else if (apiResponse.data.errors && apiResponse.data.errors.length > 0) {
      if (apiResponse && apiResponse?.status === 400 && checkInvalidCaseCartError(apiResponse.data.errors)) {
        shippingInvalidCaseError = true;
        serviceDetails = getServiceUrlandE2eRequestId('updateShipping', apiResponse);
        yield put({ type: Constants.SHIPPING_INVALID_CASE_ERROR, response: shippingInvalidCaseError, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      } else if (apiResponse.data.errors && apiResponse.data.errors.length > 0) {
        serviceDetails = getServiceUrlandE2eRequestId('updateShipping', apiResponse);
        yield put({ type: 'INVALID_ADDRESS', isInvalidAddressError: true, response: apiResponse.data, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      hideLoader();
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `updateShipping ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    } else if (apiResponse && apiResponse.request && apiResponse.request.status !== 200) {
      errorShipping = true;
      serviceDetails = getServiceUrlandE2eRequestId('updateShipping', apiResponse);
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    } else {
      hideLoader();
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));
      // logError('updateShipping', apiResponse.data.errors, FE_API_ERROR);
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `updateShipping ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'updateShipping',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
  }
}
function* updateContactInfo({ data, homePhoneAdded }) {
  let errorShipping = false;
  let shippingInvalidCaseError = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.SHIPPING_INVALID_CASE_ERROR, response: shippingInvalidCaseError });
  yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const apiResponse = yield call(Actions.updateISPUContactInfo, data, homePhoneAdded);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        yield put({ type: 'UPDATE_CONTACT_SUCCESS', response: apiResponse.data });
      }
      hideLoader();
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        if (apiResponse && apiResponse?.status === 400 && checkInvalidCaseCartError(apiResponse.data.errors)) {
          shippingInvalidCaseError = true;
          serviceDetails = getServiceUrlandE2eRequestId('updateContactInfo', apiResponse);
          yield put({ type: Constants.SHIPPING_INVALID_CASE_ERROR, response: shippingInvalidCaseError, serviceinfo: serviceDetails });
          yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        } else if (apiResponse.data && apiResponse.data.errors) {
          errorShipping = true;
          serviceDetails = getServiceUrlandE2eRequestId('updateContactInfo', apiResponse);
          yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        }
        hideLoader();
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.SHIPPING_INVALID_CASE_ERROR, response: shippingInvalidCaseError, serviceinfo: serviceDetails });
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      serviceDetails = {
        method: 'updateContactInfo',
      };
      yield put({ type: Constants.ERR_OCCURED, errorShipping, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_SHIPPING_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    hideLoader();
  }
}
function* clearDevicesFromStore(data) {
  try {
    yield put({ type: 'CLEAR_DEVICES_STORE', response: data });
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
  }
}
function* toggleContactSuccess() {
  try {
    yield put({ type: 'TOGGLE_CONTACT_SUCCESS' });
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
  }
}
export function* validateEmailFunc(data) {
  try {
    showLoader();
    const apiResponseEmailValidation = yield call(contactActions.emailValidationAPI, data);
    if (apiResponseEmailValidation && apiResponseEmailValidation.data) {
      if (apiResponseEmailValidation?.data?.maxAttempts && apiResponseEmailValidation?.data?.valid === 'false') {
        yield put({ type: 'EMAIL_MAX_ATTEMPTS', response: true });
      } else if (apiResponseEmailValidation.data.valid === 'Manual_validation') {
        apiResponseEmailValidation.data.accMainEmailVal = { success: false };
      }
      hideLoader();
      yield put({ type: 'EMAIL_VALIDATION', response: apiResponseEmailValidation.data });
    } else {
      logError('error occured in emailValidation()');
    }
  } catch (error) {
    hideLoader();
  }
}
function* emailValidation({ data }) {
  yield validateEmailFunc(data);
}
export function* accMaintenenceEmailValidationFunc(data) {
  console.log('cal l from shipping page for email verify');
  try {
    const apiResponseAccMainEmailValidation = yield call(contactActions.accMainEmailValidation, data);
    if (apiResponseAccMainEmailValidation && apiResponseAccMainEmailValidation.data && apiResponseAccMainEmailValidation.data.error !== null) {
      if (apiResponseAccMainEmailValidation?.data?.data === null) {
        yield put({ type: 'EMAIL_VALIDATION', response: { valid: 'true' } });
      } else {
        yield put({ type: Constants.ACC_MAIN_EMAIL_VALIDATION, response: { success: false } });
      }
    } else if (apiResponseAccMainEmailValidation && apiResponseAccMainEmailValidation.data && apiResponseAccMainEmailValidation.data.error === null) {
      yield put({ type: Constants.ACC_MAIN_EMAIL_VALIDATION, response: { success: true } });
    }
  } catch (error) {
    logError('error');
    hideLoader();
  }
}
function* accMaintenenceEmailValidation(data) {
  yield accMaintenenceEmailValidationFunc(data);
}
function* actionWatcher() {
  yield takeLatest(Constants.GET_DETAILS_FROM_API, getShippingInfoData);
  yield takeLatest(Constants.GET_SLOTS_SDD, getSlotsSDD);
  yield takeLatest(Constants.GET_ENABLED_DEVICES, getEnabledDevices);
  yield takeLatest(Constants.GET_SEND_SMS, sendSms);
  yield takeLatest(Constants.CODE_VALIDATION, codeValid);
  yield takeLatest('SAVE_SELECTED_OPTION', selectedShippingOption);
  yield takeLatest(Constants.POST_SHIPPING_OPTION, updateShippingOptionsData);
  yield takeLatest('GET_ISPU_STORE_LIST', getISPUStores);
  yield takeLatest('UPDATE_ISPU_SHIPPING', updateISPUShipping);
  yield takeLatest('RESET_STORE_LIST', resetStoreList);
  yield takeLatest('CLEAR_DEVICES', clearDevicesFromStore);
  yield takeLatest('UPDATE_CONTACT_INFO', updateContactInfo);
  yield takeLatest(Constants.UPDATE_SHIPPING_ADDRESS, updateShipping);
  yield takeLatest(Constants.EMAIL_VALIDATION_SHIPPING_API, emailValidation);
  yield takeLatest(Constants.ACCOUNT_MAINTENENCE_SHIPPING_EMAIL_VERIFICATION, accMaintenenceEmailValidation);
  yield takeLatest(Constants.GET_ZIP_DETAILS_FROM_API, cityAndState);
  yield takeLatest('TOGGLE_CONTACT_SUCCESS', toggleContactSuccess);
}
export default function* rootSaga() {
  yield all([actionWatcher()]);
}
